<template>
    <div class="">
        <div id="divName">  
            <v-card class="divName">
                <div v-if="ticket.status == 'quotation'" class="quotation-watermark">cotización</div>
                <img width="150" :src="empresa.logo"/>
                <div class="fiscal">
                    <strong>{{empresa.razon_social}}</strong>
                    <br/>
                    <span style="font-weight:500;">{{empresa.rfc}}</span>
                    <br/>
                    {{empresa.direccion}}
                </div>
                <div class="user">
                    {{dateFormat(ticket.created_at)}}
                    <br/>
                    <strong v-if="ticket.status ==  'vendido'"># Ticket:</strong>
                    <strong v-else-if="ticket.status ==  'quotation'"># Cotización:</strong>
                    {{ticket.id}}
                    <br/>
                    <strong>Atendió:</strong> {{currentUser.name}} {{currentUser.last}}
                    <span v-if="clientName"><br/><strong>Cliente:</strong> {{clientName}}</span>
                    <span v-if="ticketPaymentLabel"><br/><strong>Método de pago:</strong> {{ticketPaymentLabel}}</span>
                    <span v-if="date!=''"><br/><strong>Fecha de Entrega:</strong> {{dateFormat(date)}}</span>
                </div>
                <div v-if="cart.length>0">
                    <v-row class="products pb-0">
                        <v-col cols="1" class="pb-0">
                            <strong style="font-size:8px;">Cant</strong>
                        </v-col>
                        <v-col cols="7" class="pb-0">
                            <strong style="font-size:8px;">Producto</strong>
                        </v-col>
                        <v-col cols="4" style="padding-left:10px!important;" class="pb-0">
                            <v-container fill-height fluid>
                                <v-row align="center" justify="center">
                                    <v-spacer/>
                                    <strong style="font-size:8px;">Subtotal</strong>
                                </v-row>
                            </v-container>
                        </v-col>
                    </v-row>
                    <v-row class="products"  v-for="(item, index) in cart" v-bind:key="index">
                        <v-col cols="1">
                            {{formatQuantity(item.quantity)}} <!--span v-if="item.product.unit!=undefined">{{item.product.unit.name}}</span--><!--span v-if="(item.quantity*1)>1">s</span-->
                        </v-col>

                        <v-col cols="7">
                            sku:{{item.product.code_one}} | {{item.product.name}} | ${{priceWithIva(unitPrice(item)).toFixed(2)}}<!--{{item.product.unit}}<span v-if="(item.quantity*1)>1">s</span-->
                        </v-col>
                        
                        <v-col cols="4" style="padding-left:10px!important;">
                            <v-container fill-height fluid>
                                <v-row align="center" justify="center">
                                    $
                                    <v-spacer/>
                                {{priceWithIva(lineSubtotal(item)).toFixed(2)}}
                                </v-row>
                            </v-container>
                        </v-col>

                    </v-row>
                </div>

                <div v-else>
                    <v-row class="products pb-0">
                        <v-col cols="1" class="pb-0">
                            <strong style="font-size:8px;">Cant</strong>
                        </v-col>
                        <v-col cols="7" class="pb-0">
                            <strong style="font-size:8px;">Producto</strong>
                        </v-col>
                        <v-col cols="4" style="padding-left:10px!important;" class="pb-0">
                            <v-container fill-height fluid>
                                <v-row align="center" justify="center">
                                    <v-spacer/>
                                    <strong style="font-size:8px;">Subtotal</strong>
                                </v-row>
                            </v-container>
                        </v-col>
                    </v-row>

                    <v-row class="products" v-for="(item, index) in ticket.items" v-bind:key="index">
                        <v-col cols="1">
                            <div>
                                {{formatQuantity(item.quantity)}} <!--span v-if="item.product.unit!=undefined">{{item.product.unit.name}}</span--><!--span v-if="(item.quantity*1)>1">s</span-->
                            </div>
                        </v-col>
                                
                        <v-col cols="7">
                            sku:{{item.product.code_one}} | {{item.product.name}} | ${{priceWithIva(unitPrice(item)).toFixed(2)}} <!--{{item.product.unit}}<span v-if="(item.quantity*1)>1">s</span-->
                        </v-col>
                        
                        <v-col cols="4" style="padding-left:10px!important;">
                            <v-container fill-height fluid>
                                <v-row align="center" justify="center">
                                    $
                                    <v-spacer/>
                                    {{priceWithIva(lineSubtotal(item)).toFixed(2)}}
                                </v-row>
                            </v-container>
                        </v-col>

                    </v-row>
                </div>



                <div class="totals">
                    <!--v-row>
                        <span>Subtotal M.N.</span>
                        <v-spacer/>
                        <span>${{ticket.subtotal.toFixed(2)}}</span>
                    </v-row>
                    <v-row>
                        <span>IVA M.N.</span>
                        <v-spacer/>
                        <span>${{ticket.iva.toFixed(2)}}</span>
                    </v-row-->
                    <v-row v-if="discount > 0" style="font-size:13px;">
                        <span>Descuento</span>
                        <v-spacer/>
                        <span>-${{discount.toFixed(2)}}</span>
                    </v-row>
                    <v-row style="font-weight:600; font-size:14px;">
                        <span>Total M.N.</span>
                        <v-spacer/>
                        <span>${{totalToShow.toFixed(2)}}</span>
                    </v-row>
                    <v-row v-if="liga != 'https://backendmf.unocrm.mx/'">
                        <span>IVA INCLUIDO</span>
                        <v-spacer/>
                        <span>16%</span>
                    </v-row>
                </div>

                <div style="font-size:12px;" v-if="ticket.self_invoice_url">
                    <strong>Genera tu factura aquí</strong>
                    <qrcode-vue :value="ticket.self_invoice_url" renderAs="svg" size="60" style="margin: 15px 0px;"></qrcode-vue>
                    <strong>Solicita tu factura el mismo día</strong>
                </div>

                <div class="fiscal">
                    Cuentanos como te atendimos ingrsando a {{empresa.website}}
                    <br/>
                    Línea Expres WhatsApp: {{empresa.telefono}}
                    <br/>
                    Línea Corporativa: {{empresa.celular}}
                    <br/>
                    <span v-if="ticket.status ==  'vendido'">Gracias por su compra</span>
                    
                </div>
            </v-card>
        </div>  
        <v-card-actions style="background:white;">
            <!--v-btn v-if="allowCancelSale" color="red darken-1" text :loading="cancelSaleLoading" :disabled="cancelSaleLoading" @click="$emit('cancel-sale')">Cancelar venta</v-btn>
            <v-spacer v-if="allowCancelSale"></v-spacer-->
            <v-btn color="blue darken-1" text @click="dalecandela('divName')">Imprimir</v-btn>            
            <!--v-btn color="blue darken-1" v-if="this.correo(this.imprimir.contacto)!=null&&this.correo(this.imprimir.contacto)!=''&&this.correo(this.imprimir.contacto)!=undefined" text @click="sendEmail()">Enviar</v-btn>
            <v-btn color="blue darken-1" text @click="ticketRegalo('divName')">Ticket de Regalo</v-btn-->
        </v-card-actions>
    </div>
</template>

<script>
    import QrcodeVue from 'qrcode.vue'
    import fiscal_catalogs from '../../mixins/fiscal_catalogs'
    import printManagedTicket from './printManagedTicket'
    //import emailjs from 'emailjs-com';
    //import{ init } from 'emailjs-com';
    //init("user_8a0ZvcQvBK8YSEM7Sades");
    export default {
        mixins: [fiscal_catalogs],
        props:{
            ticket:Object,
            managedClose: {
                type: Boolean,
                default: false
            },
            discount: {
                type: Number,
                default: 0
            },
            displayTotal: {
                type: Number,
                default: null
            },
            allowCancelSale: {
                type: Boolean,
                default: false
            },
            cancelSaleLoading: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            datePicker:false,
            date:''
        }),
        components: {
            QrcodeVue,
        },
        computed: { 
            totalToShow(){
                if(this.displayTotal !== null && this.displayTotal !== undefined && this.displayTotal !== ''){
                    return Number(this.displayTotal || 0)
                }
                const base = this.liga != 'https://backendmf.unocrm.mx/' ? this.ticket.total : this.ticket.subtotal
                return Number(base || 0)
            },
            currentUser(){
                return this.$store.state.currentUser.user
            },
            clientName(){
                const company = this.ticket?.company?.attributes || this.ticket?.company || {}
                return company.name || company.razon_social || ''
            },
            cart() {
                if((this.ticket?.items || []).length > 0){
                    return []
                }

                return this.$store.state.cart.carts
            },
            empresa(){
                return {
                    banco: process.env.VUE_APP_BANCO,
                    cuenta: process.env.VUE_APP_CUENTA,
                    clabe: process.env.VUE_APP_CLABE,
                    razon_social: process.env.VUE_APP_RAZON_SOCIAL,
                    rfc: process.env.VUE_APP_RFC,
                    direccion: process.env.VUE_APP_DIRECCION,
                    website: process.env.VUE_APP_WEBSITE,
                    telefono: process.env.VUE_APP_TELEFONO,
                    whatsapp: process.env.VUE_APP_WHATSAPP,
                    logo: process.env.VUE_APP_LOGO
                }
            },
            liga(){
                return process.env.VUE_APP_BACKEND_ROUTE
            },
            ticketPaymentLabel(){
                const paymentFormValue = this.ticket?.payment_form
                const paymentFormLabel = this.payment_forms.find(
                    form => String(form.value) === String(paymentFormValue)
                )?.text || paymentFormValue
                return paymentFormLabel || ''
            },
        },
        methods:{
            priceWithIva(value){
                return Number(value || 0) * 1.16
            },
            unitPrice(item){
                const price = item?.price ?? item?.product?.price ?? 0
                return Number(price || 0)
            },
            lineSubtotal(item){
                return Number(item?.quantity || 0) * this.unitPrice(item)
            },
            formatQuantity(quantity){
                const value = Number(quantity)
                if(!Number.isFinite(value)){
                    return ''
                }

                return Number(value.toFixed(2)).toString()
            },
            /*
            sendEmail() {
                emailjs.send("service_kjstmjc","template_3o9pox9",{
                    fecha: this.fechita(),
                    cliente: this.cliente(this.imprimir.contacto),
                    email: this.correo(this.imprimir.contacto),
                    productos: this.losproductos(this.imprimir.productos),
                    valor: this.imprimir.valor.toLocaleString('es-MX', { style: 'currency', currency: 'MXN',}),
                    subtotal:(this.imprimir.valor/1.16).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',}),
                    iva:(this.imprimir.valor-(this.imprimir.valor/1.16)).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',}),
                    descuento:((this.imprimir.descuento)*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})
                }).then(response => {
                    location.reload();
                })
                .catch(error =>{ 
                    this.sendEmail()
                })
            },
            */
            dalecandela(divName) {
                if (this.managedClose) {
                    printManagedTicket(divName);
                    this.$emit("cerrarTicket", this.falso);
                    return;
                }
                var printContents = document.getElementById(divName).innerHTML;
                var originalContents = document.body.innerHTML;
                document.body.innerHTML = printContents;
                window.print();
                this.$nextTick(() => {
                        var is_opera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
                        var is_Edge = navigator.userAgent.indexOf("Edge") > -1;
                        var is_chrome = !!window.chrome && !is_opera && !is_Edge;
                        var is_explorer= typeof document !== 'undefined' && !!document.documentMode && !is_Edge;
                        var is_firefox = typeof window.InstallTrigger !== 'undefined';
                    if(is_opera || is_Edge || is_chrome || is_explorer || is_firefox){
                        document.body.innerHTML = originalContents;
                        this.$emit("cerrarTicket", this.falso);
                        location.reload();
                    }
                })
            },
            dalecandelamovil(divName) {
                var printContents = document.getElementById(divName).innerHTML;
                document.body.innerHTML = printContents;
                window.print()
                /*
                .then(resp=>{
                    document.body.innerHTML = originalContents;
                    this.$emit("cerrarTicket", this.falso);
                    location.reload();
                })
                */
            },
            daledoblecandela(divName){
                var printContents = document.getElementById(divName).innerHTML;
                var originalContents = document.body.innerHTML;
                document.body.innerHTML = printContents;
                window.print();
                document.body.innerHTML = originalContents;
                this.$emit("cerrarTicket", this.falso);
            },
            cerrar(){
                this.$emit("cerrar", 'hola');
            },
            parseTicketDate(rawDate){
                const value = String(rawDate || '').trim()
                if(value === ''){
                    return null
                }

                const ddmmyyyyMatch = value.match(/^(\d{2})-(\d{2})-(\d{4})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?$/)
                if(ddmmyyyyMatch){
                    const [, day, month, year, hour = '00', minute = '00', second = '00'] = ddmmyyyyMatch
                    return new Date(
                        Number(year),
                        Number(month) - 1,
                        Number(day),
                        Number(hour),
                        Number(minute),
                        Number(second)
                    )
                }

                const normalizedDate = value.includes('T')
                    ? value
                    : value.includes(' ')
                        ? value.replace(' ', 'T')
                        : value + 'T00:00:00'
                return new Date(normalizedDate)
            },
            dateFormat(date){
                const rawDate = String(date || '').trim()
                if(rawDate === ''){
                    return ''
                }
                const fecha = this.parseTicketDate(rawDate)
                if(fecha == null){
                    return ''
                }
                if(Number.isNaN(fecha.getTime())){
                    return rawDate
                }
                // Creamos array con los días de la semana
                const dias_semana = ['Domingo', 'Lunes', 'martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
                // Creamos array con los meses del año
                const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
                const hora = fecha.toLocaleTimeString('es-MX', {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true,
                })
                // Construimos el formato de salida
                if(fecha.getUTCFullYear()!=new Date().getUTCFullYear()){
                    return dias_semana[fecha.getDay()] + ', ' + fecha.getDate() + ' de ' + meses[fecha.getMonth()] + ' a las ' + hora
                }else{
                    return dias_semana[fecha.getDay()] + ', ' + fecha.getDate() + ' de ' + meses[fecha.getMonth()] + ' de ' + fecha.getUTCFullYear() + ' a las ' + hora
                }
                
            },
        }
    }
</script>

<style>
    .divName{
        font-family: Arial, Helvetica, sans-serif !important;
        text-transform: uppercase!important;
        text-align: center !important;
        padding: 30px 20px;
        color:black!important;
        position: relative;
        overflow: hidden;
        background: white;
    }
    .divName > *:not(.quotation-watermark) {
        position: relative;
        z-index: 1;
    }
    .quotation-watermark {
        position: absolute;
        top: 60%;
        left: 50%;
        z-index: 0;
        transform: translate(-50%, -50%) rotate(-28deg);
        color: rgba(0, 0, 0, 0.07);
        font-size: 36px;
        font-weight: 800;
        letter-spacing: 2px;
        line-height: 1;
        pointer-events: none;
        white-space: nowrap;
    }
    .fiscal {
        font-size: 11px;
        margin: 15px 0px;
    }
    .products{
        text-align: left !important;
        font-size: 12px;
        border-bottom:1px solid black;
        margin:0px;
    }
    .products .col{
        padding:0px 0px;
    }
    .user{
        text-align: left !important;
        font-size: 11px;
        margin-bottom:15px;
    }
    .totals{
        font-size: 12px;
        margin:20px 0px 30px 0px;
    }
    .totals .row{
        margin:0px;
    }
</style>
